export default "__VITE_ASSET__DlM12XLJ__"